// MEDIUM_SIZE has icon_size of 24px to FILLED variants and 32px to NON_FILLED
// To allow this, the icon size is not set in the size prop, but in the variant
export const buildMediumIconSize = (FOUNDATIONS) => ({});
//# sourceMappingURL=medium.js.map